import React from 'react'
import { Pagination } from 'react-admin'

export default {
  perPage: 50,
  pagination: <Pagination rowsPerPageOptions={[25, 50, 100]} />
}
